/**
 * @generated SignedSource<<9a924c3b1f66a32b67654c09e15bfd7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentBlockClearDataMutation$variables = {
  id: string;
};
export type ContentBlockClearDataMutation$data = {
  readonly contentBlockClearData: {
    readonly success: boolean | null;
  } | null;
};
export type ContentBlockClearDataMutation = {
  response: ContentBlockClearDataMutation$data;
  variables: ContentBlockClearDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ContentBlockClearData",
    "kind": "LinkedField",
    "name": "contentBlockClearData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentBlockClearDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentBlockClearDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eabb6807e39f4df759855625447c5d9",
    "id": null,
    "metadata": {},
    "name": "ContentBlockClearDataMutation",
    "operationKind": "mutation",
    "text": "mutation ContentBlockClearDataMutation(\n  $id: ID!\n) {\n  contentBlockClearData(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "50914a98e275e7a0577f49a7b8e71ce6";

export default node;
